import React, { Component } from 'react';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { connect } from 'react-redux';


import {
  NOTIFICATION_DISPLAY_TIME_LONG,
  NOTIFICATION_STATUS,
} from '../constants';
import { resetNotification } from '../redux/actions';
import 'react-notifications/lib/notifications.css';

class Notification extends Component {

  componentDidUpdate() {
    const { notificationVisible } = this.props;
    if (notificationVisible) {
      this.setUpNotification();
    }
    this.props.resetNotification();
  }

  setUpNotification() {
    const { status, message } = this.props;
    switch (status) {
      case NOTIFICATION_STATUS.info:
        NotificationManager.info(
          message,
          status,
          NOTIFICATION_DISPLAY_TIME_LONG,
        );
        break;
      case NOTIFICATION_STATUS.success:
        NotificationManager.success(
          message,
          status,
          NOTIFICATION_DISPLAY_TIME_LONG,
        );
        break;
      case NOTIFICATION_STATUS.warning:
        NotificationManager.warning(
          message,
          status,
          NOTIFICATION_DISPLAY_TIME_LONG,
        );
        break;
      case NOTIFICATION_STATUS.error:
        NotificationManager.error(
          message,
          status,
          NOTIFICATION_DISPLAY_TIME_LONG,
        );
        break;
      default:
        break;
    }
  }

  render() {
    return (
      <NotificationContainer className="notification-container" />
    );
  }
}

const mapStateToProps = ({ notification }) => {
  const { notificationVisible, notificationData } = notification;
  return {
    notificationVisible,
    message: notificationData.message,
    status: notificationData.status,
  };
};

export default connect(mapStateToProps, { resetNotification })(Notification);
